//import { refreshAsync } from "features/identity/identitySlice";
import { createApi, FileItem } from "common";
import { get, size } from "lodash";
//import * as Sentry from "sentry-expo";
import settings from "./settings";
export type { ApiResponse } from "common";

let store: any;
export function injectStore(_store: any) {
  store = _store;
}

let refreshFunc: any;
export function injectRefreshFunc(_refreshFunc: any) {
  refreshFunc = _refreshFunc;
}

const transformFieldOptions = (options: any) => {
  if (!options) {
    return [];
  }
  if (!Array.isArray(options) && typeof options === "object") {
    const keys = Object.keys(options);
    if (typeof options[keys[0]] === "string") {
      options = keys.map(key => ({ label: options[key], id: key }));
    } else {
      options = keys.map(key => ({ ...options[key], id: key }));
    }
  }
  return options.map((option: any) => ({
    ...option,
    value: option.id, //isNaN(key) ? key : parseInt(key),
    label: option.label,
  }));
};

export const transformOptions = (baseFields: any, key: string = "data") => {
  let options: any = {};

  Object.keys(baseFields).forEach(field => {
    const rawOptions = get(baseFields, `${field}.${key}`);
    if (rawOptions) {
      options[field] = transformFieldOptions(rawOptions);
    }
  });
  return options;
};

export const transformColumnOptions = (baseFields: any) => {
  let options: any = {};
  let columns: any[] = [];
  let keys = baseFields.columnsOrder || Object.keys(baseFields.columns);

  keys.forEach((field: string) => {
    const rawOptions = get(baseFields, `columns.${field}`);
    if (rawOptions) {
      const filter = get(rawOptions, "filter.type");
      options[field] = transformFieldOptions(get(rawOptions, "filter.data"));
      columns.push({
        headerName: rawOptions.name,
        field,
        flex: 1,
        //filter,
      });
    }
  });

  return { options, columns };
};

export const formErrorParser = (response: any) => {
  const form_errors = get(response, "form_errors", {});
  let errors: any = {};
  Object.keys(form_errors).forEach(field => {
    if (
      size(form_errors[field]) > 0 &&
      typeof form_errors[field][0] === "object"
    ) {
      errors[field] = form_errors[field];
    } else {
      errors[field] = form_errors[field].join(", ");
    }
  });
  return errors;
};

const api = createApi(
  () => store,
  settings,
  () => refreshFunc,
  {
    baseURL: settings.apiHost,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Accept-Language": settings.i18n.locale,
    },
    timeout: settings.requestTimeout,
  },
  {
    /*headers: (state: RootState) => {
      if (state?.clientSelector?.selectedClient) {
        //return { "X-PartyId": state.clientSelector.selectedClient };
      }
    },*/
    /*axiosFatalErrorHandler: error => {
      Sentry.Native.captureException(error);
    },*/
    itemParser: data => data?.data,
    listParser: data =>
      data?.data
        ? {
            total: data?.total || size(data?.data),
            data: data?.data,
            current_page: data?.page || 1,
            per_page: data["per-page"] || 20,
            totals: data?.total || size(data?.data),
          }
        : {},
    paginationParser: data => ({
      success: true,
      error: false,
      data: data?.data,
      total: data?.total || 0,
      pageSize: data ? data["per-page"] || 20 : 20,
      page: data?.page || 1,
    }),
    formErrorParser,
    optionParser: (data, component = "form") => {
      if (component === "grid") {
        if (data && data.data && data.data?.grid) {
          return transformColumnOptions(data.data.grid);
        }
      } else {
        if (data && data.data && data.data[component].baseFields) {
          return transformOptions(data.data[component].baseFields);
        }
      }
      return {};
    },
    uploadFile: async (file: FileItem, access_token: string) => {
      var formData = new FormData();
      formData.append("file", file as any);

      const { success, data } = await api.post("/files", formData, {
        headers: { "Content-Type": "multipart/form-data;" },
        transformRequest: data => data,
      });

      if (success) {
        return {
          ...file,
          name: data.data.file_name,
          id: data.data.file_id,
          uri: data.data.file_url,

          //uri: `${settings.apiHost}/files/download/${data.data.file_id}?accessToken=${access_token}`,
        };
      }
    },
  }
);
export default api;
